import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import App from "../App";
import Home from "@/pages/home/home";
import CRMLayout from "@/features/crm/layout";

import { Suspense } from "react";
import {
  LoginSignup,
  BlogDetails,
  BlogsListing,
  KanbanBoard,
  LeadDetails,
  Listing,
  ComingSoon,
  Calendar,
  Contacts,
  AllApps,
  Quotes,
  Contracts,
  Invoicing,
  MarketingAutomation,
  DiscussLayout,
  Inbox,
  DirectMessage,
  AddLead,
  ListView,
  ActivityView,
  PaymentSuccess,
  Integration,
  CRMConfigurations,
  LoginForm,
  ForgotPasswordForm,
  ForgotPasswordOtpForm,
  ForgotPasswordReEnterPasswordForm,
  NewBMPAgent,
  EditLeadDetails,
  AdminLogin,
  AdminUserList,
  NewBMPAgent1,
  Analytics,
  CompanyProfileShareable,
  CompanyProfile,
} from "./lazyImports";
import Loading from "./loading";
import Home2 from "@/pages/newHome/newHome";

import MyAccount from "@/features/user-profile/layout";
import Subscription from "@/features/user-profile/subscriptions/subscriptions";
import OrganizationUsers from "@/features/user-profile/organization-user/organization-users";
import AccountSetting from "@/features/user-profile/account-setting/accountSetting";
import Integrations from "@/features/user-profile/integration/integrations";
import UserProfile from "@/features/user-profile/userProfile/userProfile";
// import CompanyProfile from "@/features/user-profile/company-profile/companyProfie";
// import ProtectedRoute from "./protected-route";
import AdminProtectedRoute from "@/routes/admin-protected-route";
import ProtectedRoute from "./protected-route";
import AuthErrorPage from "./auth-error-page";
import SubUserList from "@/features/admin/users-list/user-list";
import UserDetails from "@/features/admin/users-list/user-Details";
import TermsAndConditions from "@/pages/newHome/screens/LandingPage/sections/termsConditions";
import PrivacyPolicy from "@/pages/newHome/screens/LandingPage/sections/privacyPolicy";
import ProfileDetailsFormPage from "@/features/user-profile/company-profile/dialogCompanyDetails/edit-companyDetails.tsx";
import AddNewProject from "@/features/user-profile/company-profile/ui/add-new-project";
import CreateCompanyProfileForm from "@/features/user-profile/company-profile/dialogCompanyDetails/company-createDetails";
import EditBuilderProject from "@/features/user-profile/company-profile/ui/edit-builder-project";
import WatchBuilders from "@/features/user-profile/watch-builders/watchBuilders";
import SelectivelyProtectedRoute from "./selectively-protected-route";
// import CreateCompanyDetailsForm from "@/features/user-profile/company-profile/dialogCompanyDetails/createCompanyDetails";

{
  /* fallback={
    <div className="loading-overlay">
      <div className="spinner z-50">
        <GridLoader color="#28af4a" />
      </div>
    </div>
  } */
}

// const isAuth = Boolean(localStorage.getItem("accessToken"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<App />}>
        <Route
          path="auth"
          element={
            <Suspense fallback={<Loading />}>
              <LoginSignup />
            </Suspense>
          }
        >
          <Route
            index
            // path="login"
            element={
              <Suspense fallback={<Loading />}>
                <LoginForm />
              </Suspense>
            }
          />
          <Route
            index
            path="forget-password"
            element={
              <Suspense fallback={<Loading />}>
                <ForgotPasswordForm />
              </Suspense>
            }
          />
          <Route
            index
            path="forget-password-otp"
            element={
              <Suspense fallback={<Loading />}>
                <ForgotPasswordOtpForm />
              </Suspense>
            }
          />
          {/* <Route
            index
            path="set-password"
            element={
              <Suspense fallback={<Loading />}>
                <ForgotPasswordReEnterPasswordForm />
              </Suspense>
            }
          /> */}
          <Route
            index
            path="buildmapper_agent"
            element={
              <Suspense fallback={<Loading />}>
                <NewBMPAgent />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="profile"
          element={
            // <ProtectedRoute>
            <MyAccount />
            // {/* </ProtectedRoute> */}
          }
        >
          {/* Nested Routes - These render inside MyAccount (keeping the sidebar) */}
          <Route
            index
            path="organization-users"
            element={
              <Suspense fallback={<Loading />}>
                <OrganizationUsers />
              </Suspense>
            }
          />
          <Route
            path="company-profile"
            element={
              <Suspense fallback={<Loading />}>
                <CompanyProfile />
              </Suspense>
            }
          ></Route>
          <Route
            path="company-profile/edit"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <ProfileDetailsFormPage />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="builder-watchlist"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <WatchBuilders />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="company-profile/add"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <CreateCompanyProfileForm />
                  {/* <CreateCompanyDetailsForm/> */}
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="company-profile/add-new-project"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <AddNewProject />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="company-profile/builder-project/edit"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <EditBuilderProject />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="user-profile"
            element={
              <Suspense fallback={<Loading />}>
                <UserProfile />
              </Suspense>
            }
          />
          <Route
            index
            path="account-setting"
            element={
              <Suspense fallback={<Loading />}>
                <AccountSetting />
              </Suspense>
            }
          />
          <Route
            index
            path="integrations"
            element={
              <ProtectedRoute >
                <Suspense fallback={<Loading />}>
                  <Integrations />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="subscription"
            element={
              <Suspense fallback={<Loading />}>
                <Subscription />
              </Suspense>
            }
          />
        </Route>

        <Route path="admin">
          <Route index element={<AdminLogin />} />
          <Route path="login" element={<AdminLogin />} />
          <Route element={<AdminProtectedRoute />}>
          <Route
            path="dashboard"
            element={
              <Suspense fallback={<Loading />}>
                <AdminUserList />
              </Suspense>
            }
          >
            <Route index element={<SubUserList />} />

            <Route path="all-users" element={<SubUserList />} />
            <Route path="subscribed-users" element={<SubUserList />} />
            <Route path="users/:id" element={<UserDetails />} />
            </Route>
          </Route>
        </Route>

        <Route index element={<Home2 />} />
        <Route path="dashboard" element={<CRMLayout />}>

        <Route
            index
            path="organization-users"
            element={
              <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <OrganizationUsers />
              </Suspense>
              </ProtectedRoute>
            }
          />

<Route
            path="builder-watchlist"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <WatchBuilders />
                </Suspense>
              </ProtectedRoute>
            }
          />
<Route
            path="company-profile"
            element={
              <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <CompanyProfile />
              </Suspense>
              </ProtectedRoute>
            }
          ></Route>

          <Route
            path="company-profile/edit"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <ProfileDetailsFormPage />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="company-profile/add"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <CreateCompanyProfileForm />
                  {/* <CreateCompanyDetailsForm/> */}
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="company-profile/add-new-project"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <AddNewProject />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="company-profile/builder-project/edit"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <EditBuilderProject />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="user-profile"
            element={
          
              <Suspense fallback={<Loading />}>
                <UserProfile />
              </Suspense>
         
            }
          />
          <Route
            index
            path="account-setting"
            element={
              <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <AccountSetting />
              </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="integrations"
            element={
              <ProtectedRoute >
                <Suspense fallback={<Loading />}>
                  <Integrations />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="subscription"
            element={
              <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <Subscription />
              </Suspense>
              </ProtectedRoute>
            }
          />
        

          <Route
            path="buildmapper_agent"
            element={
              <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                {/* <BMPAgent /> */}
                <NewBMPAgent1 />
              </Suspense>
              </ProtectedRoute>
            }
          />

          <Route path="forbidden" element={<AuthErrorPage />} />
          <Route
            index
            path="CRM"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <KanbanBoard />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="leads/:id"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <LeadDetails />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="leads/edit/:id"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <EditLeadDetails />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="CRM/add_lead"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <AddLead />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="CRM/configurations"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <CRMConfigurations />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="explore_leads"
            element={
              <SelectivelyProtectedRoute>
              <Suspense fallback={<Loading />}>
                <Listing />
              </Suspense>
              </SelectivelyProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={<Loading />}>
                <ComingSoon />
              </Suspense>
            }
          />
          <Route
            path="calendar"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <Calendar />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="CRM/list_view"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <ListView />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="CRM/activity_view"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <ActivityView />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="all_apps"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <AllApps />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="integration"
            element={
              <ProtectedRoute  forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <Integration />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="contacts"
            element={
              <ProtectedRoute forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <Contacts />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="quotes"
            element={
              <ProtectedRoute forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <Quotes />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="contracts"
            element={
              <ProtectedRoute forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <Contracts />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="invoicing"
            element={
              <ProtectedRoute forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <Invoicing />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="automation"
            element={
              <ProtectedRoute forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <MarketingAutomation />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="analytics"
            element={
              <ProtectedRoute forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <Analytics />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="discuss"
            element={
              <ProtectedRoute forceOverlay={true}>
                <Suspense fallback={<Loading />}>
                  <DiscussLayout />
                </Suspense>
              </ProtectedRoute>
            }
          >
            <Route
              // index
              path="inbox"
              element={
                <Suspense fallback={<Loading />}>
                  <Inbox />
                </Suspense>
              }
            />
            <Route
              index
              path="message"
              element={
                // <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <DirectMessage />
                </Suspense>
                // </ProtectedRoute>
              }
            />
          </Route>
        </Route>
        <Route
          path="blogs"
          element={
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <BlogsListing />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="blogs/:id"
          element={
            <Suspense fallback={<Loading />}>
              <BlogDetails />
            </Suspense>
          }
        />
        <Route
          path="payment-success/:id"
          element={
            <Suspense fallback={<Loading />}>
              <PaymentSuccess />
            </Suspense>
          }
        />
        <Route
          path="home_01"
          element={
            <Suspense fallback={<Loading />}>
              <Home />
            </Suspense>
          }
        />
        <Route
          index
          path="set-password"
          element={
            <Suspense fallback={<Loading />}>
              <ForgotPasswordReEnterPasswordForm />
            </Suspense>
          }
        />
        <Route
          path="terms_and_conditions"
          element={
            <Suspense fallback={<Loading />}>
              <TermsAndConditions />
            </Suspense>
          }
        />
        <Route
          path="privacy_policy"
          element={
            <Suspense fallback={<Loading />}>
              <PrivacyPolicy />
            </Suspense>
          }
        />
        <Route
          path="company-profile/shareable"
          element={
            <Suspense fallback={<Loading />}>
              <CompanyProfileShareable />
            </Suspense>
          }
        />

        {/* <Route
            path="company-profile/sharable"
            element ={<Suspense fallback={<Loading />}>
              <CompanyProfileShareable  />
            </Suspense>} /> */}

        {/* <Route
            index
            path="/admin/all-users"
            element={
              <Suspense fallback={<Loading />}>
                <AdminUserList />
              </Suspense>
            }
          /> */}
      </Route>
    </>
  )
);

export default router;
